import React from "react";
import ct from "class-types.macro";
import { BannerType } from "../shared/definitions";
import SingleProduct from "../shared/SingleProduct";
import { SideBySideProductCompareItem } from "../../ProductDetailPageResult";
import connectUserAndChat, { User } from "~/common/Store/connectUserAndChat";

interface Props {
  sideBySideProductCompareItem: SideBySideProductCompareItem;
  currentProductTitle?: string;
  user: User;
  mounted: boolean;
  originalLinkingItemNumber: string;
}

const SideBySide = ({
  sideBySideProductCompareItem,
  currentProductTitle,
  user,
  mounted,
  originalLinkingItemNumber,
}: Props) => {
  const cn = ct(
    "bg-white",
    "border-gray-200",
    "rounded",
    "border-solid",
    "border",
    "flex",
    "flex-col",
    "mt-3",
    "mb-3",
    "overflow-hidden",
    "relative",
    "lt:flex-row",
  );
  return (
    <>
      {mounted && sideBySideProductCompareItem && (
        <div
          id="spotlight-banner-SideBySide"
          data-testid="spotlight-banner-SideBySide"
          className={cn}
          suppressHydrationWarning
        >
          <SingleProduct
            originalLinkingItemNumber={originalLinkingItemNumber}
            item={sideBySideProductCompareItem}
            bannerType={BannerType.SideBySide}
            currentProductTitle={currentProductTitle}
            user={user}
          />
        </div>
      )}
    </>
  );
};

export default connectUserAndChat(SideBySide);
